import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';

import { ArrowL16 } from '@cian/ui-kit/icons';
import { InlineText1 } from '@cian/ui-kit/typography';

type TGoBackButtonProps = React.ComponentProps<'button'>;

export const GoBackButton: React.FC<TGoBackButtonProps> = props => {
  return (
    <button {...props} className={cn(styles['button'], props.className)} data-testid="prevQ">
      <span className={styles['icon']}>
        <ArrowL16 color={'current_color'} display={'block'} />
      </span>
      <InlineText1 color={'current_color'}>{props.children}</InlineText1>
    </button>
  );
};

GoBackButton.displayName = 'GoBackButton';
